import React from 'react'

const BecomePartnerFormField = () => {
    return (
        <>
            <section className="become-partner-form-field">
                <section className="get-in-touch">

                    {/* <h1 className="title">Get in touch</h1> */}
                    <form className="contact-form row">
                        <div className='col-lg-12'>
                            <div className='form-heading-cus'><h5>Personal Information</h5></div>
                        </div>
                        <div className="form-field col-lg-6">
                            <input id="name" className="input-text js-input"  type="text" required="" />
                            <label className="label" htmlFor="name"> Full Name </label>
                        </div>
                        <div className="form-field col-lg-6 dob-cus-dv">
                            <input id="dob" className="input-text js-input"  type="date" required="" placeholder='' />
                            <label className="label" htmlFor="dob"> Date of Birth </label>
                        </div>
                        <div className="form-field col-lg-6">
                        <select class="form-select input-text js-input" aria-label="Default select example">
                            <option selected>Gender</option>
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                            <option value="3">Other</option>
                        </select>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="email" className="input-text js-input" type="email" required="" />
                            <label className="label" htmlFor="email"> E-mail </label>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="phonelbl" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="phonelbl"> Phone </label>
                        </div>
                        <div className='col-lg-12'>
                            <div className='form-heading-cus'><h5>Personal Information</h5></div>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="street-address" className="input-text js-input"  type="text" required="" />
                            <label className="label" htmlFor="street-address"> Street Address  </label>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="city" className="input-text js-input"  type="text" required="" />
                            <label className="label" htmlFor="city"> City  </label>
                        </div>
                        <div className="form-field col-lg-6">
                        <select class="form-select input-text js-input" aria-label="Default select example">
                            <option selected>State/Province</option>
                            <option value="1">UP</option>
                            <option value="2">BR</option>
                            <option value="3">MP</option>
                        </select>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="postal-code" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="postal-code"> Postal Code </label>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="country" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="country"> Country </label>
                        </div>
                        <div className='col-lg-12'>
                            <div className='form-heading-cus'><h5>Professional Information</h5></div>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="current-job-title" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="current-job-title"> Current Job Title  </label>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="current-company" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="current-company"> Current Company (if applicable)  </label>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="industry-experience" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="industry-experience"> Industry Experience </label>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="linkedin-profile" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="linkedin-profile"> LinkedIn Profile </label>
                        </div>
                        <div className='col-lg-12'>
                            <div className='form-heading-cus'><h5>Business Information</h5></div>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="company-name" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="company-name"> Company Name (if applicable) </label>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="company-website" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="company-website"> Company Website (if applicable)  </label>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="business-address" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="business-address"> Business Address (if different from personal)  </label>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="business-discription" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="business-discription"> Business Description  </label>
                        </div>
                        <div className='col-lg-12'>
                            <div className='form-heading-cus'><h5>Motivation and Interest</h5></div>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="briefly" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="briefly"> Briefly explain why you're interested in becoming an associate sales partner.  </label>
                        </div>
                        <div className="form-field col-lg-6 ">
                            <input id="what-quality" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="what-quality"> What qualities/skills do you believe make you a good fit for this role? </label>
                        </div>
                        <div className='col-lg-12'>
                            <div className='form-heading-cus'><h5>Referral Source</h5></div>
                        </div>
                        <div className="form-field col-lg-8">
                            <select id='' class="form-select input-text js-input" aria-label="Default select example">
                                <option selected>How did the applicant learn about the associate sales partner opportunity? </option>
                                <option value="1">Website</option>
                                <option value="2">Referral</option>
                                <option value="3">Social Media</option>
                            </select>
                        </div>
                        <div className='col-lg-12'>
                            <div className='form-heading-cus'><h5>Availability and Commitment</h5></div>
                        </div>
                        <div className="form-field col-lg-6">
                            <select id='' class="form-select input-text js-input" aria-label="Default select example">
                                <option selected>Availability </option>
                                <option value="Part-time">Part-time</option>
                                <option value="Full-time">Full-time</option>
                            </select>
                        </div>
                        <div className="form-field col-lg-6">
                            <input id="many-hours" className="input-text js-input" type="text" required="" />
                            <label className="label" htmlFor="many-hours"> How many hours per week can you commit to this role? </label>
                        </div>
                        <div className='col-lg-12'>
                            <div className='form-heading-cus'><h5>Agreements and Consent</h5></div>
                        </div>
                        <div className="form-field col-lg-6">
                            <div className='checkbox-cus-hd'>
                                <input id="share-personal" className="" type="checkbox" required="" />
                                <label className="label" htmlFor="share-personal"> Consent to share personal and professional information for verification purposes.</label>
                            </div>
                        </div>
                        <div className="form-field col-lg-6">
                            <div className='checkbox-cus-hd'>
                                <input id="agreement-term" className="" type="checkbox" required="" />
                                <label className="label" htmlFor="agreement-term">Agreement to terms and conditions of the associate sales partner program. </label>
                            </div>
                        </div>
                        <div className='col-lg-12'>
                            <div className='form-heading-cus'><h5>Uploads</h5></div>
                        </div>
                        <div className="form-field col-lg-6 form-fld-cus-dv">
                            <input id="resume" className="input-text js-input" type="file" required="" />
                            <span style={{ fontSize: 12,color:'red' }}>PDF or Word document</span>
                            <label className="label" htmlFor="resume">Resume/CV</label>
                        </div>
                        <div className="form-field col-lg-6 form-fld-cus-dv">
                            <input id="resume" className="input-text js-input" type="file" required="" />
                            {/* <span style={{ fontSize: 12,color:'red' }}>Cover Letter </span> */}
                            <label className="label" htmlFor="resume">Cover Letter</label>
                        </div>
                        <div className="form-field col-lg-6 form-fld-cus-dv">
                            <input id="resume" className="input-text js-input" type="file" required="" />
                            {/* <span style={{ fontSize: 12,color:'red' }}>Any other relevant documents or certifications</span> */}
                            <label className="label" htmlFor="resume">Any other relevant documents or certifications</label>
                        </div>
                        <div className="form-field col-lg-6 form-fld-cus-dv">
                            <input id="resume" className="input-text js-input" type="file" required="" />
                            <span style={{ fontSize: 12,color:'red' }}>Adhar Card, Passport, Voter ID</span>
                            <label className="label" htmlFor="resume">ID Proof</label>
                        </div>
                        <div className='col-lg-12'>
                            <div className='form-heading-cus'><h5>Preferred Contact Method</h5></div>
                        </div>
                        <div className="form-field col-lg-6">
                        {/* <label className="label" htmlFor="resume">How would the applicant prefer to be contacted? </label> */}
                        <select id='business-discription1' class="form-select input-text js-input" aria-label="Default select example">
                                <option selected>How would the applicant prefer to be contacted? </option>
                                <option value="Part-time">Email</option>
                                <option value="Full-time">Phone</option>
                            </select>
                        </div>

                        <div className="form-field col-lg-12">
                            <input className="submit-btn" type="submit" defaultValue="Submit" />
                        </div>
                    </form>
                </section>

            </section>
        </>
    )
}

export default BecomePartnerFormField